import { render, staticRenderFns } from "./MuvekkilVekaletUcretleriForm.vue?vue&type=template&id=19658696&scoped=true"
import script from "./MuvekkilVekaletUcretleriForm.vue?vue&type=script&lang=ts"
export * from "./MuvekkilVekaletUcretleriForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19658696",
  null
  
)

export default component.exports